import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

export function usePageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    console.log("[GA]", "pageview", location);
    ReactGA.send("pageview");
  }, [location]);
}
